import React, { useState } from "react";
import styles from "./styles.module.scss";
import { localizedStrings } from "src/localization/index.jsx";
import { Image } from "react-bootstrap";
import GmailLogo from "src/legacy/images/gmail_logo.png";
import BackButton from "src/legacy/components/BackButton";
import _ from "lodash";
import SwitchButton from "src/components/switchButton";
// import SwitchButton from "src/legacy/components/Switch/Switch";

export const GmailSideBar = (props) => {


const localizedIntegrations = localizedStrings.components.integrations;
const localizedGmail = localizedStrings.components.integrations.gmail;
const localizedCommons = localizedStrings.commons;
const localizedIntgerationActions = localizedStrings.components.integrations.actions;
const integration = localizedStrings.constants.integrationsOnboarding.integrations.gmail;
const support_articles =  localizedStrings.constants.integrationsOnboarding.integrations.gmail.support_articles;

const [showSeeMore, setShowSeeMore] = useState(true);

const handleChange = () => {
    props.showIntergrationOnboarding();
}

const handleSeeMore = () => {
    const container = document.getElementById('articles');
    const element = container.querySelector('ol li:last-child');
    if (container) {
      const scrollHeight = element.offsetTop;
      container.scrollTo({ top: scrollHeight, behavior: "smooth" });
    }
    setShowSeeMore(false);
  }

return (
    <div className={styles.sideBar}>
    <BackButton
        className={styles.back}
        title={localizedCommons.actions.back}
        onClick={() => {
            props.navigate("/settings/integrations");
        }}
    />
    <div className={styles.headerContainer}>
    <div className={styles.heading}>
        <Image src={GmailLogo} />
        <h2 className={styles.name}>{localizedGmail.title}</h2>
        <p className={styles.description}>{localizedGmail.sub_text}</p>
    </div>
    
    <div className={styles.actions}>
        {((_.size(_.get(props, "integration")) > 0 && !props.isAuthenticated) || (_.size(_.get(props, "integration")) > 0 && props.isTokenExpired)) &&
        <button 
            onClick={() => props.handleAuthenticate()}
            disabled={props.authenticating} className={styles.button}>
            {props.authenticating ? localizedIntgerationActions.authenticating + "..." : localizedIntgerationActions.re_authenticate}
        </button>
        }

        {_.size(_.get(props, "integration")) == 0 &&
            !props.isAuthenticated && (
            <button
                onClick={() => props.handleAuthenticate()}
                disabled={props.authenticating}
                className={styles.button}
            >
            {props.authenticating &&
                localizedIntgerationActions.authenticating + "..."}
            {!props.authenticating &&
                localizedIntgerationActions.authenticate}
            </button>
        )}

        {_.size(_.get(props, "integration")) > 0 &&
            props.isAuthenticated &&
            !props.isTokenExpired &&(
            <button
                className={styles.button}
                disabled={props.deactivating}
                onClick={() => props._handleDeactivateClicked()}
            >
            {props.deactivating &&
                `${localizedIntgerationActions.deactivating}...`}
            {!props.deactivating && localizedIntgerationActions.deactivate}
            </button>
        )}
    </div>
    </div>

    <div className={styles.footerContainer}>
    <div className={styles.footer}>
    <div
        className={styles.articles}
        id="articles"
    >
        <span>{support_articles.title}</span>
        <ol>
        {support_articles.content.map((article, index) => {
            return (
            <li key={index} className={styles.article}>
                <a href={article.url} target="_blank">{article.title}</a>
            </li>
            )
        })}
        </ol>
    </div>

    {_.size(support_articles.content) > 4 && showSeeMore && (
        <div className={styles.seeMore} onClick={handleSeeMore}>{localizedCommons.actions.see_more}</div>
    )}
    {_.size(_.get(props, "integration")) > 0 && (
        <div className={styles.moreActions}>
            <span>{localizedIntegrations.learn_more}</span>
            <SwitchButton
             id="integrationOnboarding"
             label={localizedIntgerationActions.show_onboarding_label}
             className={styles.switch}
             checked={props.isShowIntegrationOnboardingEnabled}
             handleCheck={() => handleChange()}
             />
        </div>
    )} 
    </div>
    </div>
    </div>
);
};
